import { Link } from 'react-router-dom';
import { Section } from '@/components/layout';
import { Reveal } from '@/components/motion';
import { TOUR_HUB_PATH } from '@/features/events';
import styles from './SiguienteNivelBogota.module.css';

/* =============================================================================
 * S8 · VOLVER A LA GIRA — ADICIÓN EXIGIDA POR EL BRIEF
 * -----------------------------------------------------------------------------
 * Lo pide `07_ARQUITECTURA_LANDINGS.md` §6.7: enlace de vuelta a la landing
 * general. ADR-006 §3 manda colocar las adiciones antes del cierre, así que vive
 * aquí y no encima del hero, para no tocar la composición que sí manda el mockup.
 *
 * ── QUÉ SE FUE DE AQUÍ, Y POR QUÉ (28-jul-2026) ──────────────────────────────
 * Esta sección llevaba TAMBIÉN el upsell a Cancún: una tarjeta centrada, con
 * corona y sin foto. Miami tenía otra distinta, México una tercera dentro de su
 * banda de cierre, y Buenos Aires la horizontal con fotografía. Cuatro ciudades,
 * tres maneras de contar el MISMO escalón del embudo.
 *
 * El cliente revisó `/buenos-aires` en vídeo (28-jul-2026), señaló esa cuarta
 * —«El nivel final del recorrido»— y pidió que fuera la de todas. Así que el
 * upsell pasa a ser el bloque compartido `CancunUpsell`, que además ya trae la
 * línea de continuidad («el recorrido de la gira termina aquí») y su propio
 * botón de reserva. Lo monta `BogotaPage` justo antes de la FAQ.
 *
 * Aquí se queda sólo el enlace de vuelta, que es lo otro que esta sección hacía
 * y que no duplicaba nadie. No se borra el fichero: el enlace tiene que seguir
 * existiendo, y su sitio en la pila es éste.
 * ========================================================================== */
export function SiguienteNivelBogota() {
  return (
    <Section background="alt" className={styles.section}>
      <Reveal className={styles.backWrap}>
        <Link className={styles.back} to={TOUR_HUB_PATH}>
          <span aria-hidden="true">←</span> Volver a la gira
        </Link>
      </Reveal>
    </Section>
  );
}
